<button matButton [matMenuTriggerFor]="menu" #projectionTriggerBtn="matMenuTrigger" (menuOpened)="menuOpened()" >
  {{controlService.activeProj()?.name| translate}}
  <mat-icon>arrow_drop_down
  </mat-icon>
</button>
<mat-menu #menu="matMenu" yPosition="above">
  <!-- overlapTrigger="true" -->
  @for (projection of projections; track projection.name + '-' + projection.epsg) {
  <button mat-menu-item [ngClass]="controlService.activeProj()?.name === projection?.name ? 'active':''"
    (click)="setProjection(projection)">
    <span>{{ projection.name|translate}}</span>
  </button>
  }
</mat-menu>
<div id="mouse-coords">
  <div class="tt-mouse-coords">
    <span [innerHTML]="controlService.formattedCoords()"></span>
  </div>
</div>